import { useEffect, useState } from 'react';

const canMatchMedia = () => typeof window.matchMedia === 'function';

/** Whether a media query matches right now (false where matchMedia does not exist). */
export const matchesMediaQuery = (query: string) =>
  canMatchMedia() && window.matchMedia(query).matches;

/** Whether a CSS media query (an OS preference) matches, kept live while the app is open. */
export const useMediaQuery = (query: string) => {
  const [isMatch, setIsMatch] = useState(() => matchesMediaQuery(query));

  useEffect(() => {
    if (!canMatchMedia()) {
      return undefined;
    }

    const mediaQuery = window.matchMedia(query);
    const handleChange = (event: { matches: boolean }) => setIsMatch(event.matches);

    setIsMatch(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return isMatch;
};
